(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/jackpot-bar/assets/javascripts/jackpot-bar.js') >= 0) return;  svs.modules.push('/components/tur/jackpot-bar/assets/javascripts/jackpot-bar.js');
"use strict";


svs.tur = svs.tur || {};
svs.tur.JackpotBar = class JackpotBar {
  constructor() {
    this.el = document.getElementsByClassName('js-jackpot-bar')[0];
    if (!this.el) {
      return {};
    }
  }
};

 })(window);